import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import LanguageSwitcher from './LanguageSwitcher';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { href: '#apropos', label: 'À propos' },
    { href: '#services', label: 'Nos services' },
    { href: '#Catalogue', label: 'Catalogue' },
    { href: '#contact', label: 'Contact' },
  ];

  const handleNavClick = (e, href) => {
    e.preventDefault();
    window.dispatchEvent(new Event('close-quote'));
    setIsOpen(false);
    setTimeout(() => { window.location.hash = href; }, 0);
  };

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-gray-200 shadow-sm py-4">
      <div className="container mx-auto px-4 flex items-center justify-between">
        <a href="#apropos" className="flex items-center space-x-4">
          <div className="w-11 h-11 rounded-md bg-gray-900 text-white flex items-center justify-center text-xl font-bold tracking-tight">
            M
          </div>
          <div className="leading-tight">
            <div className="text-lg font-extrabold text-gray-900">Metal JelJeli</div>
            <div className="text-sm text-gray-500">Découpe laser & design métal</div>
          </div>
        </a>

        <nav className="hidden md:flex items-center space-x-8">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e)=>handleNavClick(e, item.href)}
              className="text-[15px] text-gray-700 hover:text-gray-900 transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center space-x-3">
          <a href="#devis" className="hidden md:inline-flex items-center px-4 py-2 rounded-md bg-gray-900 text-white text-sm font-semibold hover:bg-black transition-colors">
            Demande de devis
          </a>
          <LanguageSwitcher />
          <button
            aria-label="Toggle menu"
            className="md:hidden inline-flex items-center justify-center w-11 h-11 rounded-lg border border-gray-200"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden border-t border-gray-200 bg-white">
          <div className="px-4 py-4 space-y-2">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e)=>handleNavClick(e, item.href)}
                className="block px-2 py-3 rounded-md text-gray-700 hover:bg-gray-50"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;


